import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ShareMovementButton } from "@/components/home/ShareMovementButton";
import { CtaEmailCapture } from "@/components/home/CtaEmailCapture";
import { HOME } from "@/constants/testIds";

const PRINTIFY_URL = "https://bias-buster-store.printify.me/";

export default function DonationBand() {
  return (
    <section className="bg-[#EAF3F7] border-y border-bbap-border py-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-display font-extrabold uppercase text-2xl md:text-3xl text-zinc-950 tracking-tight mb-4">
          Fund the Movement
        </h2>
        <p className="text-zinc-600 max-w-2xl mx-auto mb-8">
          Every donation helps us build BERN — our emergency response network — and fund the advocacy work
          that pushes for real change. Every shirt worn is a visible signal that you stand for accountability.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/donate" data-testid={HOME.ctaDonateButton}>
            <Button size="lg" className="bg-[#1E3A6E] text-white font-semibold rounded-none px-10 py-6 text-base hover:bg-zinc-950 hover:shadow-[0px_4px_0px_0px_#4FD1C5] w-full sm:w-auto">
              Donate Now
            </Button>
          </Link>
          <ShareMovementButton testId={HOME.ctaShareButton} className="border-zinc-300 text-zinc-950 rounded-none hover:border-zinc-950 w-full sm:w-auto" />
          <a href={PRINTIFY_URL} target="_blank" rel="noopener noreferrer" data-testid={HOME.ctaMerchButton} className="w-full sm:w-auto">
            <Button size="lg" variant="outline" className="border-zinc-300 text-zinc-600 rounded-none hover:border-zinc-950 hover:text-zinc-950 w-full sm:w-auto">
              Shop Merch <ExternalLink className="h-4 w-4 ml-2" />
            </Button>
          </a>
        </div>
        <div className="mt-10 pt-8 border-t border-zinc-300 max-w-sm mx-auto">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-3">Not ready yet? Join the email list</p>
          <CtaEmailCapture />
        </div>
      </div>
    </section>
  );
}
